export const CONVERSATION_PARTS = [
  'container',
  'content',
  'scrollButton',
  'scrollButtonPositioner',
  'skeleton',
] as const;
